import { render, staticRenderFns } from "./ItemDetailLink.vue?vue&type=template&id=2fba4354&scoped=true"
import script from "./ItemDetailLink.vue?vue&type=script&lang=js"
export * from "./ItemDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba4354",
  null
  
)

export default component.exports